import React, { useEffect, useState } from "react";
import Aside from "../common/Asside";
import Header from "../common/Header";

function Profile() {
    const [profileData, setProfileData] = useState(null); // State for storing profile data
    // eslint-disable-next-line no-unused-vars
    const [activeTab, setActiveTab] = useState("Earnings");
    const [historyTab, sethistoryTab] = useState("bank");
    
    const [playerData, setPlayerData] = useState([]);
    


    const [visibleModal, setVisibleModal] = useState({
      passwordChangeModal: false,
      editPhoneModal: false,
      historyModal: false,
      applyWithdrawModal: false,
      
    });
  // State to track the list of contact info
    const [contactInfoList, setContactInfoList] = useState([
      { id: 0, contactType: "", callingCode: "", value: "" }
    ]);
  // Handle adding a new contact info item
  // eslint-disable-next-line no-unused-vars
  const addContactInfo = () => {
    setContactInfoList([
      ...contactInfoList,
      { id: contactInfoList.length, contactType: "", callingCode: "", value: "" }
    ]);
  };

  // Handle deleting a contact info item
  // eslint-disable-next-line no-unused-vars
  const deleteContactInfo = (id) => {
    setContactInfoList(contactInfoList.filter((item) => item.id !== id));
  };

  // Handle updating a contact info item
  // eslint-disable-next-line no-unused-vars
  const handleContactInfoChange = (id, field, value) => {
    setContactInfoList(
      contactInfoList.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [username, setUsername] = useState("");
  const [amount, setAmount] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  // Home P&L (Affiliate Profit & Loss) list for current period breakdown
  // eslint-disable-next-line no-unused-vars
  const [plList, setPlList] = useState([]);
  // We don't care about cycle status; use first element consistently as This Period
  const [aaItems, setAaItems] = useState([]); // Home Commission periods
  const [plThisPeriod, setPlThisPeriod] = useState(null); // Matched P&L item for This Period (items[0])
  const [plLoading, setPlLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setMessage(null);
  
    try {
      const token = localStorage.getItem("token");
  
      const response = await fetch("https://api2b.pro/api/change-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword,
          new_password_confirmation: confirmNewPassword,
        }),
      });
  
      const result = await response.json();
  
      if (response.ok) {
        setMessage("✅ Password changed successfully!");
        setTimeout(() => toggleModal("passwordChangeModal"), 1500);
      } else {
        setMessage(`❌ ${result.message || "Something went wrong."}`);
      }
    } catch (error) {
      setMessage("❌ Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  const handleWithdrawlSubmit = async () => {
    setLoading(true);
    setMessage(null);
  
    try {
      const token = localStorage.getItem("token");
  
      const response = await fetch("https://api2b.pro/api/affiliate/adjust-balance", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          amount: amount,
          username: username,
        }),
      });
  
      const result = await response.json();
  
      if (response.ok) {
        setMessage("✅ Withdrawal transfer successfully!");
        setTimeout(() => toggleModal("applyWithdrawModal"), 1500);
      } else {
      
        console.error(`❌ API Error: ${response.status}`, result);
  
        // 🧾 Show user-friendly message
        setMessage(`❌ ${result.message || `Request failed with status ${response.status}`}`);
      }
    } catch (error) {
      console.error("❌ Fetch Error:", error);
      setMessage("❌ Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch the same data used on Home (Affiliate Profit & Loss list)
  const fetchHomePL = async () => {
    setPlLoading(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10s timeout to avoid hanging
    try {
      const token = localStorage.getItem('token');
      const response = await fetch("https://api2b.pro/api/afiiliateindexnew", {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        signal: controller.signal
      });
      if (!response.ok) throw new Error(`Failed to fetch Affiliate P&L data (status ${response.status})`);
  const result = await response.json();
      const list = Array.isArray(result?.profit_and_loss) ? result.profit_and_loss : [];
  setPlList(list);
      const items = Array.isArray(result?.actual_affiliate?.items) ? result.actual_affiliate.items : [];
      setAaItems(items);
      // This Period = first element
      setPlThisPeriod(list.length > 0 ? list[0] : null);
    } catch (e) {
      setPlLoading(false);
      if (e.name === 'AbortError') {
        console.warn('fetchHomePL aborted due to timeout');
      } else {
        console.error('fetchHomePL error:', e);
      }
      setPlList([]);
    } finally {
  clearTimeout(timeoutId);
  setPlLoading(false);
    }
  };
  
  
   
  const fetchPlayerData = async () => {
    try {
        const response = await fetch("https://api2b.pro/api/get/username", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            setPlayerData(data);
        } else {
            console.error("Failed to fetch player data");
        }
    } catch (error) {
        console.error("Error fetching player data:", error);
    }
};
  useEffect(() => {
    const fetchProfileData = async () => {
        try {
            const response = await fetch("https://api2b.pro/api/affilaite-profile", {
              method: "POST",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            });
            const data = await response.json();
            setProfileData(data); // Store the fetched data
        } catch (error) {
            console.error("Error fetching profile data:", error);
        }
    };
    fetchProfileData();
}, []);

  const toggleModal = (section) => {
    setVisibleModal((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };

  // Removed old Bet data fetch using /api/afiiliateindex
  
        
  useEffect(() => {
          fetchPlayerData();
    fetchHomePL();
  }, []);
  

  // Removed old calculateProfitLoss since old bet data was removed
  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Reuse Home breakdown calculation for a profit_and_loss item
  const calculateBreakdown = (item) => {
    const extra = item?.extra || {};
    const deposit = parseFloat(extra.deposit || 0);
    const withdraw = parseFloat(extra.withdraw || 0);
    const bonus = parseFloat(extra.bonus || 0);
    const adjustment = parseFloat(extra.adjustment || 0);
    const payerBalance = parseFloat(extra.payer_balance || 0);
    const openBets = parseFloat(extra.open_bets || 0);
    const commissionRate = parseFloat(extra.commission_rate || 0);
    const adminRate = parseFloat(extra.extra_deduction_percent || 0);

    const allDeductions = withdraw + bonus + adjustment + payerBalance + openBets;
    const loss = deposit - allDeductions;
    const mainCommission = loss * (commissionRate + adminRate);
	  const companyDeduction = loss * adminRate;
	  const finalCommission = mainCommission - companyDeduction;

    return {
      deposit,
      withdraw,
      bonus,
      adjustment,
      payerBalance,
      openBets,
      allDeductions,
      loss,
      commissionRate,
	  mainCommission,
	adminRate,
		companyDeduction,
	  finalCommission
    };
  };
  
    return(
        <div>
          <div>
      {loading ? (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
          <div
            className="blockUI blockMsg blockElement"
            style={{
              zIndex: 10010,
              position: 'absolute',
              padding: '15px',
              margin: '0px',
              width: '30%',
              textAlign: 'center',
              color: 'rgb(255, 255, 255)',
              border: 'none',
              backgroundColor: 'rgb(0, 0, 0)',
              cursor: 'default',
              borderRadius: '10px',
              opacity: '0.493912'
            }}
          >
            Loading...
          </div>
          <div className="modal-backdrop fade active"></div>
        </div>
      ) : (
        <div>
         
        </div>
      )}
    </div>
  <Header />
  <div className="container-flex">
    <Aside />
    <div className="main">
      <div className="page-content">
      {visibleModal.passwordChangeModal && (
        <div id="modal_EaODiy5nEe" className="modal d-flex">
          <div className="modal-dialog">
            <div className="modal-head">
              <h4>Edit Password</h4>
              <button
                onClick={() => toggleModal("passwordChangeModal")}
                type="button"
                className="btn-ic-grey modal-close"
              >
                <span className="ic-close" />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group form-column">
                <label className="label bold">Password</label>
                <input
                  className="form-control"
                  type="password"
                  name="currentPassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  aria-required="true"
                />
              </div>
              <div className="form-group form-column">
                <label className="label bold">New Password</label>
                <input
                  className="form-control"
                  type="password"
                  id="newPassword"
                  name="newPassword"
                  aria-required="true"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className="form-group form-column">
                <label className="label bold">Confirm Password</label>
                <input
                  className="form-control"
                  type="password"
                  name="confirmNewPassword"
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  aria-required="true"
                />
              </div>
              {message && <p style={{ color: "red", marginTop: "10px" }}>{message}</p>}
            </div>
            <div className="modal-foot">
              <button
                onClick={() => toggleModal("passwordChangeModal")}
                id="modalCancelBtn_EaODiy5nEe"
                type="button"
                className="btn-light modal-close"
              >
                Cancel
              </button>
              <button
               onClick={handleSubmit}
                id="modalSubmitBtn_EaODiy5nEe"
                type="button"
                className="btn-primary"
                disabled={loading}
              >
              {loading ? "Updating..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
      {visibleModal.historyModal && (
      <div id="modal_gkMftsTKwu" className="modal d-flex">
      <div className="modal-dialog">
        <div className="modal-head">
          {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
          <h4 />
          <h4>View</h4>
          <button onClick={() => toggleModal("historyModal")} type="button" className="btn-ic-grey modal-close"><span className="ic-close" /></button>
        </div>
        <div className="modal-body">
          <div id="withdrawHistoryTab">
            <ul className="section_tab" style={{display: 'block'}}>
              <li className="section_tab-item">
                <a className={`section_tab-link  ${historyTab === "bank" ? "active" : ""}`}
                            onClick={() => sethistoryTab("bank")} href="#bank">
                  Bank
                </a>
              </li>
              <li className="section_tab-item">
              <a className={`section_tab-link  ${historyTab === "player" ? "active" : ""}`}
                            onClick={() => sethistoryTab("player")} href="#player">
                  Player
                </a>
              </li>
            </ul>
            <div className="section d-block" >
             {historyTab === "bank" && (
               <div className="section-body fade active" id="myAccountHistory">
               <form action="#" id="myAccountHistoryForm" noValidate="novalidate">
                 <div className="card">
                   <div className="card-head bg-primary">History</div>
                   <div className="card-body">
                     <div className="form-group form-column form-2-col">
                       <label className="label bold">Currency </label>
                       <select className="form-control" name="currencyTypeId">
                         <option value={8}>BDT </option>
                       </select>
                       <input type="hidden" name="txnType" defaultValue={1} />
                     </div>
                     <div className="form-group form-column form-2-col">
                       <label className="label bold">Bank </label>
                       <select className="form-control" name="toTargetId">
                         <option value={-1}>All </option>
                       </select>
                     </div>
                     <div className="form-group form-column form-2-col">
                       <label className="label bold">From </label>
                       <input type="date" className="form-control" name="start" defaultValue="2024-10-28" />
                     </div>
                     <div className="form-group form-column form-2-col">
                       <label className="label bold">To </label>
                       <input type="date" className="form-control" name="end" defaultValue="2024-11-04" />
                     </div>
                     <hr />
                     <div className="table-wrap">
                       <div id="myAccountHistoryTable_wrapper" className="dataTables_wrapper no-footer">
                         <div className="dt-buttons">
                           <button className="dt-button buttons-collection buttons-colvis" tabIndex={0} aria-controls="myAccountHistoryTable" type="button" aria-haspopup="true" aria-expanded="false">
                             <span>Column visibility</span>
                           </button>
                         </div>
                         <table id="myAccountHistoryTable" className="dataTable no-footer" role="grid" aria-describedby="myAccountHistoryTable_info">
                           <thead>
                             <tr role="row">
                               <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="#">#</th>
                               <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Application ID
                       ">
                                 Application ID
                               </th>
                               <th className="sorting_desc" tabIndex={0} aria-controls="myAccountHistoryTable" rowSpan={1} colSpan={1} aria-sort="descending" aria-label="Apply Time
                       : activate to sort column ascending">
                                 Apply Time
                               </th>
                               <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Currency
                       ">
                                 Currency
                               </th>
                               <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Amount
                       ">
                                 Amount
                               </th>
                               <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Status
                       ">
                                 Status
                               </th>
                               <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Bank
                       ">
                                 Bank
                               </th>
                               <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Branch
                       ">
                                 Branch
                               </th>
                               <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Bank Card No.
                       ">
                                 Bank Card No.
                               </th>
                             </tr>
                           </thead>
                           <tbody>
                             <tr className="odd">
                               <td valign="top" colSpan={9} className="dataTables_empty">No data available in table</td>
                             </tr>
                           </tbody>
                         </table>
                         <div className="dataTables_paginate paging_simple_numbers" id="myAccountHistoryTable_paginate">
                           <a className="paginate_button previous disabled" aria-controls="myAccountHistoryTable" data-dt-idx={0} tabIndex={0} id="myAccountHistoryTable_previous" href="#prev">Previous</a><span />
                           <a className="paginate_button next disabled" aria-controls="myAccountHistoryTable" data-dt-idx={1} tabIndex={0} id="myAccountHistoryTable_next" href="#next">Next</a>
                         </div>
                         <div className="dataTables_length" id="myAccountHistoryTable_length">
                           <label>
                             Show
                             <select name="myAccountHistoryTable_length" aria-controls="myAccountHistoryTable" className>
                               <option value={10}>10</option>
                               <option value={25}>25</option>
                               <option value={50}>50</option>
                               <option value={100}>100</option>
                             </select>
                             entries
                           </label>
                         </div>
                         <div className="dataTables_info" id="myAccountHistoryTable_info" role="status" aria-live="polite">Showing 0 to 0 of 0 entries</div>
                       </div>
                     </div>
                   </div>
                 </div>
               </form>
             </div>
             )}
              {historyTab === "player" && (
                <div className="section-body fade active" id="downlineHistory">
                <form action="#" id="downLineHistoryForm" noValidate="novalidate">
                  <div className="card">
                    <div className="card-head bg-primary">History</div>
                    <div className="card-body">
                      <div className="form-group form-column form-3-col">
                        <label className="label bold">Player </label>
                        <select className="form-control" name="toTargetId">
                          <option value>All </option>
                          
                        </select>
                        <input type="hidden" name="txnType" defaultValue={2} />
                      </div>
                      <div className="form-group form-column form-3-col">
                        <label className="label bold">From </label>
                        <input type="date" className="form-control" name="start" defaultValue="2024-10-28" />
                      </div>
                      <div className="form-group form-column form-3-col">
                        <label className="label bold">To </label>
                        <input type="date" className="form-control" name="end" defaultValue="2024-11-04" />
                      </div>
                      <hr />
                      <div className="table-wrap">
                        <div id="downlineHistoryTable_wrapper" className="dataTables_wrapper no-footer">
                          <div className="dt-buttons">
                            <button className="dt-button buttons-collection buttons-colvis" tabIndex={0} aria-controls="downlineHistoryTable" type="button" aria-haspopup="true" aria-expanded="false"><span>Column visibility</span></button>
                          </div>
                          <table id="downlineHistoryTable" className="dataTable no-footer" role="grid" aria-describedby="downlineHistoryTable_info">
                            <thead>
                              <tr role="row">
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="#">#</th>
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Application ID
                                  ">
                                  Application ID
                                </th>
                                <th className="sorting_desc" tabIndex={0} aria-controls="downlineHistoryTable" rowSpan={1} colSpan={1} aria-sort="descending" aria-label="Apply Time
                                  : activate to sort column ascending">
                                  Apply Time
                                </th>
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Currency
                                  ">
                                  Currency
                                </th>
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Amount
                                  ">
                                  Amount
                                </th>
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Status
                                  ">
                                  Status
                                </th>
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Player
                                  ">
                                  Player
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="odd">
                                <td valign="top" colSpan={7} className="dataTables_empty">No data available in table</td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="dataTables_paginate paging_simple_numbers" id="downlineHistoryTable_paginate">
                            <a className="paginate_button previous disabled" aria-controls="downlineHistoryTable" data-dt-idx={0} tabIndex={0} id="downlineHistoryTable_previous" href="#prev">Previous</a><span />
                            <a className="paginate_button next disabled" aria-controls="downlineHistoryTable" data-dt-idx={1} tabIndex={0} id="downlineHistoryTable_next" href="#next">Next</a>
                          </div>
                          <div className="dataTables_length" id="downlineHistoryTable_length">
                            <label>
                              Show
                              <select name="downlineHistoryTable_length" aria-controls="downlineHistoryTable" className>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </select>
                              entries
                            </label>
                          </div>
                          <div className="dataTables_info" id="downlineHistoryTable_info" role="status" aria-live="polite">Showing 0 to 0 of 0 entries</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              
              )}
              <div className="section-body fade" id="adjustmentHistory">
                <form action="#" id="adjustmentHistoryForm" noValidate="novalidate">
                  <div className="card">
                    <div className="card-head bg-primary">History</div>
                    <div className="card-body">
                      <div className="form-group form-column form-3-col">
                        <label className="label bold">Currency </label>
                        <select className="form-control" name="currencyTypeId">
                          <option value={-1}>All </option>
                          <option value={8}>BDT </option>
                        </select>
                        <input type="hidden" name="txnType" defaultValue={1} />
                      </div>
                      <div className="form-group form-column form-3-col">
                        <label className="label bold">From </label>
                        <input type="date" className="form-control" name="start" defaultValue="2024-10-28" />
                      </div>
                      <div className="form-group form-column form-3-col">
                        <label className="label bold">To </label>
                        <input type="date" className="form-control" name="end" defaultValue="2024-11-04" />
                      </div>
                      <hr />
                      <div className="table-wrap">
                        <div id="adjustmentHistoryTable_wrapper" className="dataTables_wrapper no-footer">
                          <div className="dt-buttons">
                            <button className="dt-button buttons-collection buttons-colvis" tabIndex={0} aria-controls="adjustmentHistoryTable" type="button" aria-haspopup="true" aria-expanded="false">
                              <span>Column visibility</span>
                            </button>
                          </div>
                          <table id="adjustmentHistoryTable" className="dataTable no-footer" role="grid" aria-describedby="adjustmentHistoryTable_info">
                            <thead>
                              <tr role="row">
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="#">#</th>
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Currency
                        ">
                                  Currency
                                </th>
                                <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Amount
                        ">
                                  Amount
                                </th>
                                <th className="sorting_desc" tabIndex={0} aria-controls="adjustmentHistoryTable" rowSpan={1} colSpan={1} aria-sort="descending" aria-label="Approved Date
                        : activate to sort column ascending">
                                  Approved Date
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="odd">
                                <td valign="top" colSpan={4} className="dataTables_empty">No data available in table</td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="dataTables_paginate paging_simple_numbers" id="adjustmentHistoryTable_paginate">
                            <a className="paginate_button previous disabled" aria-controls="adjustmentHistoryTable" data-dt-idx={0} tabIndex={0} id="adjustmentHistoryTable_previous" href="#prev">Previous</a><span />
                            <a className="paginate_button next disabled" aria-controls="adjustmentHistoryTable" data-dt-idx={1} tabIndex={0} id="adjustmentHistoryTable_next" href="#next">Next</a>
                          </div>
                          <div className="dataTables_length" id="adjustmentHistoryTable_length">
                            <label>
                              Show
                              <select name="adjustmentHistoryTable_length" aria-controls="adjustmentHistoryTable" className>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </select>
                              entries
                            </label>
                          </div>
                          <div className="dataTables_info" id="adjustmentHistoryTable_info" role="status" aria-live="polite">Showing 0 to 0 of 0 entries</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-foot">
          <button id="modalCancelBtn_gkMftsTKwu" type="button" className="btn-light modal-close">Cancel</button>
          <button id="modalSubmitBtn_gkMftsTKwu" type="button" className="btn-primary reload-data">Search</button>
        </div>
      </div>
    </div>
      
      )}
        {visibleModal.editPhoneModal && (
        <div className="modal d-flex">
          <div className="modal-dialog">
            <div className="modal-head">
              <h4>Edit Contact Info</h4>
              <button
                onClick={() => toggleModal("editPhoneModal")}
                type="button"
                className="btn-ic-grey modal-close"
              >
                <span className="ic-close" />
              </button>
            </div>
            <div className="modal-body">
              <div className="mt-repeater connectionInfo">
                {contactInfoList.map((info, index) => (
                  <div key={info.id} className="d-flex mt-repeater-row">
                    <div className="form-group form-column form-5-col">
                      <select
                        className="form-control contactTypes"
                        value={info.contactType}
                        name={`contactType-${index}`}
                        disabled
                      >
                        <option value="">Select Contact Type</option>
                        <option value="1">Email</option>
                        <option value="2-1">Phone Number 1</option>
                        <option value="2-2">Phone Number 2</option>
                        <option value="4">QQ</option>
                        <option value="8">WeChat</option>
                        <option value="128">WhatsApp</option>
                      </select>
                    </div>
                    <div className="form-group form-column form-5-col">
                      <select
                        className="form-control"
                        name={`callingCode-${index}`}
                        disabled
                      >
                        <option value="1">+1</option>
                        <option value="880">+880</option>
                        <option value="91">+91</option>
                      </select>
                    </div>
                    <div className="form-group form-column form-2-col">
                      <input
                        type="text"
                        className="form-control"
                        name={`value-${index}`}
                        disabled
                      />
                    </div>
                    <div className="form-group form-column form-5-col">
                      <button
                        onClick={() => {
                          setContactInfoList(contactInfoList.filter((_, i) => i !== index));
                        }}
                        className="btn-outline-danger mt-repeater-delete"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
                <div className="d-flex float-right">
                  <button
                    onClick={() =>
                      setContactInfoList([
                        ...contactInfoList,
                        { id: contactInfoList.length, contactType: "", callingCode: "", value: "" },
                      ])
                    }
                    className="btn-outline-secondary mt-repeater-add"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-foot">
              <button
                onClick={() => toggleModal("editPhoneModal")}
                className="btn-light modal-close"
              >
                Cancel
              </button>
              <button type="button" className="btn-primary">
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {visibleModal.applyWithdrawModal && (
        <div id="modal_ck3U2w1ih2" className="modal d-flex">
        <div className="modal-dialog">
          <div className="modal-head">
            {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
            <h4 />
            <h4>Apply</h4>
            <button  onClick={() => toggleModal("applyWithdrawModal")} type="button" className="btn-ic-grey modal-close"><span className="ic-close" /></button>
          </div>
          <div className="modal-body">
            <div id="withdrawTab">
              <ul className="section_tab" style={{display: 'block'}}>
                <li className="section_tab-item">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                  <a className="section_tab-link active" href="javascript:void(0)" data-id="downline" id="tabDownline">
                    Player
                  </a>
                </li>
              </ul>
              <div className="section">
                <div className="section-body fade" id="myAccount">
                  <form action="#" id="myAccountForm" noValidate="novalidate">
                    <div className="card">
                      <div className="card-head bg-primary">Application Form</div>
                      <div className="card-body">
                        <div className="form-group form-column form-3-col">
                          <label className="label bold">Currency </label>
                          <select className="form-control"   name="currencyTypeId">
                            <option value={8} style={{display: 'block'}}>
                              BDT
                            </option>
                          </select>
                        </div>
                        <div className="form-group form-column form-3-col">
                          <label className="label bold">Bank </label>
                          <select className="form-control" name="bankId" aria-required="true"> </select>
                        </div>
                        <div className="form-group form-column form-3-col">
                          <label className="label bold">Amount </label>
                          <input className="form-control" type="number" name="amount" aria-required="true" />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="section-body fade active" id="downline">
                  <form action="#" id="downlineForm" noValidate="novalidate">
                    <div className="card">
                      <div className="card-head bg-primary">Application Form</div>
                      <div className="card-body">
                        <div name="withdrawalInfo" className="form-group form-column form-3-col is-valid">
                          <label className="label bold">Player </label>
                          <select
                              className="form-control"
                              name="designationId"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              aria-required="true"
                            >
                              <option value="">Select Player</option>
                              {playerData.map((player, index) => (
                                <option key={index} value={player.username}>
                                  {player.username}
                                </option>
                              ))}
                            </select>

                          <div id="designationId-error" className="invalid-feedback" />
                        </div>
                        <div name="withdrawalInfo" className="form-group form-column form-3-col">
                          <label className="label bold">Amount </label>
                          <input className="form-control" type="number"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          name="amount" aria-required="true" />
                        </div>
                        <div id="otpPart" className="form-group form-column form-3-col">
                          <label className="label bold">Receive OTP by</label>
                          <select className="form-control" name="contactType">
                            <option value={1}>
                              Email
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {message && <p style={{ color: "red", marginTop: "10px" }}>{message}</p>}
          </div>
          <div className="modal-foot">
            <button id="modalCancelBtn_ck3U2w1ih2" type="button" className="btn-light modal-close">Cancel</button>
            <button
               onClick={handleWithdrawlSubmit}
                id="modalSubmitBtn_EaODiy5nEe"
                type="button"
                className="btn-primary"
                disabled={loading}
              >
              {loading ? "Transfaring..." : "Submit"}
              </button>
          </div>
        </div>
      </div>
      
    
      )}
        <div className="main-inner">
          <div className="page-content-body" style={{ display: "block" }}>
            <div className="col-wrap" style={{ alignItems: "stretch" }}>
              <div className="section col-2">
                <div className="section-head">
                  <h2 className="title">Profile</h2>
                  <button  onClick={() => toggleModal("passwordChangeModal")} className="btn-ic-grey">
                    <span className="ic-setting" id="openPwdModalBtn" />
                  </button>
                </div>
                <div className="section-body">
                  <div className="d-flex">
                    <div className="form-2-col">
                      <div className="form-group form-column">
                        <div className="form-label bold">Username</div>
                        <div className="form-text">{profileData?.username}</div>
                      </div>
                      <div className="form-group form-column">
                        <div className="form-label bold">Name</div>
                        <div className="form-text">{profileData?.name}</div>
                      </div>
                      
                      <div className="form-group form-column">
                        <div className="form-label bold">Date of Birth</div>
                        <div className="form-text">{profileData?.dofb}</div>
                      </div>
                      <div className="form-group form-column">
                        <div className="form-label bold">
                          Last Withdrawal Time
                        </div>
                        <div className="form-text" />
                      </div>
                    </div>
                    <div className="form-2-col">
                      <div className="form-group form-column">
                        <div className="form-label bold">Account Status</div>
                        <div className="tag-active">{profileData?.status}</div>
                      </div>
                      <div className="form-group form-column">
                        <div className="form-label bold">
                          Approved Date and Time
                        </div>
                        <div className="form-text">{formatDate(profileData?.created_at)}</div>
                      </div>
                     
                      <div className="form-group form-column">
                        <div className="form-label bold">Referral Code</div>
                        <div className="form-text">{profileData?.referral_code}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section col-2">
                <div className="section-head">
                  <h2 className="title">Contact Info</h2>
                  <button onClick={() => toggleModal("editPhoneModal")} className="btn-ic-grey" id="openContactModalBtn">
                    <span className="ic-setting" />
                  </button>
                </div>
                <div className="section-body">
                  <div className="form-group form-column">
                    <div className="form-label bold">Phone Number 1</div>
                    <div className="form-text" id="Phone-1">
                    {profileData?.phone}
                    </div>
                    <div className="btn-phone verify">
                      <span className="phone-verify" />
                    </div>
                  </div>
                  
                  <div className="form-group form-column">
                    <div className="form-label bold">Email</div>
                    <div className="form-text" id="Email">
                    {profileData?.email}
                    </div>
                    <div className="btn-mail verify">
                      <span className="mail-verify" />
                    </div>
                  </div>
                  <div className="form-group form-column">
                    <div className="form-label bold">WhatsApp</div>
                    <div className="form-text" id="WhatsApp">
                    {profileData?.phone}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-wrap">
              <div className="section col-2">
                <div className="section-head">
                  <h2 className="title">Potential (This Period)</h2>
                </div>
                <div className="section-body">
                  {/* Use Home's Affiliate Profit & Loss breakdown for the current period */}
                  {plLoading ? (
                    <div>Loading current period breakdown...</div>
                  ) : plThisPeriod ? (
                    (() => {
                      const current = plThisPeriod;
                      const breakdown = calculateBreakdown(current);
                      const tp = aaItems[0];
                      return (
                        <div className="card">
                          <div className="card-head bg-primary">Period Summary - Commission Calculation Breakdown</div>
                          <div className="w-100">
                            <div className="d-flex ">
                              <div className="form-group form-column form-2-col">
                                <div className="form-label bold">Period</div>
                                <div className="form-text">
                                  {(tp?.start_date || current?.start_date || 'N/A')}{(tp?.end_date || current?.end_date) ? ` - ${(tp?.end_date || current?.end_date)}` : ''}
                                </div>
                              </div>
                              <div className="form-group form-column form-2-col">
                                <div className="form-label bold">Active Players</div>
                                <div className="form-text">{current?.active_players || 0}</div>
                              </div>
                            </div>

                            
                            <div style={{ fontFamily: 'monospace' }}>
                              <div className="d-flex">
                                <div className="form-group form-column form-3-col">
                                  <div className="form-label bold">Deposits</div>
                                  <div className="form-text">{breakdown.deposit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                </div>
                                <div className="form-group form-column form-3-col">
                                  <div className="form-label bold">Withdrawals</div>
                                  <div className="form-text">{breakdown.withdraw.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                </div>
                                <div className="form-group form-column form-3-col">
                                  <div className="form-label bold">Bonuses</div>
                                  <div className="form-text">{breakdown.bonus.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                </div>
                              </div>
                              <div className="d-flex">
                                <div className="form-group form-column form-3-col">
                                  <div className="form-label bold">Adjustments</div>
                                  <div className="form-text">{breakdown.adjustment.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                </div>
                                <div className="form-group form-column form-3-col">
                                  <div className="form-label bold">Payer Balance</div>
                                  <div className="form-text">{breakdown.payerBalance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                </div>
                                <div className="form-group form-column form-3-col">
                                  <div className="form-label bold">Open Bets</div>
                                  <div className="form-text">{breakdown.openBets.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                </div>
                              </div>
                              <div className="d-flex">
                                <div className="form-group form-column form-2-col">
                                  <div className="form-label bold">Total Deductions</div>
                                  <div className="form-text">{breakdown.allDeductions.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                </div>
                                <div className="form-group form-column form-2-col">
                                  <div className="form-label bold">Net Result (Deposit - Deductions)</div>
                                  <div className="form-text" style={{ color: breakdown.loss >= 0 ? '#28a745' : '#dc3545' }}>
                                    {breakdown.loss.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex">
                                <div className="form-group form-column form-2-col">
                                  <div className="form-label bold">Commission Rate</div>
                                  <div className="form-text">{((breakdown.commissionRate + breakdown.adminRate) * 100).toFixed(2)}%</div>
                                </div>
                                <div className="form-group form-column form-2-col">
                                  <div className="form-label bold">Total Commission</div>
                                  <div className="form-text" style={{ color: breakdown.mainCommission >= 0 ? '#28a745' : '#dc3545' }}>
                                    {breakdown.mainCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex">
                                <div className="form-group form-column form-2-col">
                                  <div className="form-label bold">Company Deduction</div>
									<div className="form-text">{breakdown.companyDeduction.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                </div>
                                <div className="form-group form-column form-2-col">
                                  <div className="form-label bold">Final Commission</div>
                                  <div className="form-text" style={{ color: breakdown.finalCommission >= 0 ? '#28a745' : '#dc3545' }}>
                                    {breakdown.finalCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </div>
                                </div>
							</div>
							
                            </div>
                          </div>
                        </div>
                      );
                    })()
                  ) : (
                    <div>No "This Period" data available yet.</div>
                  )}
                </div>
                <div className="section-foot">
                  <button
                    id="earningRefreshBtn"
                    className="btn-primary float-right"
                    onClick={fetchHomePL}
                  >
                    Refresh
                  </button>
                </div>
              </div>
              <div className="section col-2">
                <div className="section-head">
                  <h2 className="title">Commission</h2>
                  <div className="btn-group">
                    <div className="btn-group">
                      <select className="form-control" id="withdrawCurrency" defaultValue={8}>
                        <option value={8}>BDT</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="section-body">
                  <div
                    className="form-group form-column"
                    id="withdrawalRestriction"
                  />
                  <div className="form-group form-column">
                    <div className="form-label bold">Pending</div>
                    <div className="form-text af-number" id="pending">
                    0.00
                    </div>
                  </div>
                  <div className="form-group form-column">
                    <div className="form-label bold">Available</div>
                    <div className="form-text af-number" id="available">
                    {profileData?.balance}
                    </div>
                    <input
                      type="hidden"
                      id="availableAmount"
                      defaultValue={0}
                    />
                  </div>
                  <div className="form-group form-column">
                    <div className="form-label bold">Processing Withdrawal</div>
                    <div className="form-text af-number" id="processing">
                      0.00
                    </div>
                  </div>
                  <input
                    type="hidden"
                    id="withdrawalRestrictedActivePlayer"
                    defaultValue="true"
                  />
                  <input
                    type="hidden"
                    id="minActPlayerWithdraw"
                    defaultValue={0}
                  />
                  <input
                    type="hidden"
                    id="lastPeriodActivePlayer"
                    defaultValue={10}
                  />
                </div>
                <div className="section-foot">
                  <button
                    id="withdrawRefreshBtn"
                    className="btn-primary float-right"
                  >
                    Refresh
                  </button>
                  <button
                  onClick={() => toggleModal("applyWithdrawModal")}
                    id="withdrawApplyBtn"
                    className="btn-primary float-right"
                  >
                    Apply
                  </button>
                  {/* <button
                  onClick={() => toggleModal("historyModal")}
                    id="withdrawHistoryBtn"
                    className="btn-primary float-right"
                  >
                    View
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer">
          Copyright © 2020. All rights Reserved
        </footer>
        {/* Modal Backdrop */}
        {visibleModal.passwordChangeModal || visibleModal.editPhoneModal || visibleModal.historyModal || visibleModal.applyWithdrawModal ? (
              <div className="modal-backdrop fade active" />
            ) : null}
      </div>
    </div>
  </div>
</div>

    );
}
export default Profile;
